export default "__VITE_ASSET__DX38abhR__"